'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  hover: 0,
  autoPlay: 1,
  click: 2,
  refactoredAutoPlay: 'auto'
};